import { PlayerInfo } from './PlayerInfo';

export class TeamInfo {
  teamID: string = '';
  teamName: string = '';
  color1: string = '#DD0000';
  color2: string = '#0000DD';
  players: PlayerInfo[] = [];
}
